export var Labels = {
    useHomeAsBillingAddress: 'My billing address is the same as the address on my plan',
    addressLine1: 'Street Address',
    addressLine2: 'Apartment, unit, suite (optional)',
    city: 'City',
    state: 'State',
    zipCode: 'Zipcode'
};
export var FieldErrors = {
    invalidAddressLine1: 'Please enter a valid street address',
    invalidCity: 'Please enter a valid city',
    invalidState: 'Please select a valid state',
    invalidZipCode: 'Please enter a valid zipcode'
};
export var States = [
    { name: 'Australian Capital Territory', value: 'Australian Capital Territory' },
    { name: 'New South Wales', value: 'New South Wales' },
    { name: 'Northern Territory', value: 'Northern Territory' },
    { name: 'Queensland', value: 'Queensland' },
    { name: 'South Australia', value: 'South Australia' },
    { name: 'Tasmania', value: 'Tasmania' },
    { name: 'Victoria', value: 'Victoria' },
    { name: 'Western Australia', value: 'Western Australia' }
];
